import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15918c84"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-user-lock me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "password",
  class: "form-label text-muted"
}, " ตั้งรหัสผ่านใหม่เป็นค่าเริ่มต้น: ", -1))
const _hoisted_5 = { class: "input-group mb-2 mt-0" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-nt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-key" })
], -1))
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_9 = { class: "input-group mb-2 mt-0" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "input-group-text text-nt" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-key" })
], -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "resetPasswordForm",
    backdrop: "static",
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("รีเซ็ตรหัสผ่าน ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.password) = $event)),
              class: "form-control",
              placeholder: "กรุณาป้อนชื่อรหัสผ่าน...",
              "aria-label": "password",
              readonly: true
            }, null, 512), [
              [
                _vModelText,
                _ctx.formData.password,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", {
            for: "adminPassword",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.adminPassword}])
          }, " รหัสผ่านของผู้ดูแลระบบ: ", 2),
          (_ctx.submited && _ctx.errors.adminPassword)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " * กรุณาป้อนรหัสผ่านของผู้ดูแลระบบ "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("input", {
              type: "password",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.adminPassword) = $event)),
              class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.adminPassword}]),
              placeholder: "กรุณาป้อนรหัสผ่านของผู้ดูแลระบบ...",
              "aria-label": "adminPassword",
              autocomplete: "off",
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
            }, null, 34), [
              [
                _vModelText,
                _ctx.formData.adminPassword,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_12,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_11),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_14,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_13)
    ]),
    _: 1
  }, 8, ["onHide"]))
}